declare var require: any
import { Component,  OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { GenericService } from '../generic.service';
import { User } from '../entities/user';
import { Attestation } from '../entities/attestation';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import * as _ from 'underscore';
import {FormBuilder, FormGroup, Validators } from '@angular/forms';
import { any } from 'underscore';
import { OrderPipe } from 'ngx-order-pipe';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NotificationService } from '../notification.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DossierService } from '../dossier.service';
import { title } from 'process';
import { visitAll } from '@angular/compiler';
//import { info } from 'console';

const pdfMake = require('../../../pdfmake/pdfmake');
const pdfFonts = require('../../../pdfmake/vfs_fonts'); 
pdfMake.vfs = pdfFonts.pdfMake.vfs;  




@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.css']
})
export class AdministrationComponent implements OnInit{

  public attestion :  Attestation;
  public infoData = {
    prenom: "",
    email: "",
    pdf: {}
  }
  
  
  public showSpinner : boolean;
 /* public errorMessage: string;
  public successMessage: string;
  public justSaved  : String;
  public MsgError  : String; */

  public user: User;
  public users : User[] = [];
  //variable pour déactiver le compte d'un utilisateur
  //public isActive: boolean = false;

  public pwd: string;

  public critere = {
    nom : undefined,
    prenom : undefined,
    role : undefined,
  };

  public page : number;
  public total : number ;
  public totalPages;
  public pages;
  public sortDir = -1;//1= 'ASE' -1= DSC
  public sortKey :string;

  public dataAvailable : boolean;
  public result : any;
  public reset : boolean;

  public currentUser: User;

  public usersType: string[] = ["ADMIN", "MANAGER", "COLLABORATEUR", "ANCIEN COLLABORATEUR", "CANDIDAT"];

  //Spécifier la fonction qu'occupe un collaborateur chez Well'D
  public FONCTION: string[] = ["", "MANAGER"];



  public totalEntretien : number;
  public totalEntretienParManager : any;
  public totalDossiers : number;
  public consultantByManager: any[] = []; // pas encore utilisé
  public newAndOldConsultant  = []
  public totalCandiNonValid : number;
  public totalConsultants : number;
  public totalConsulActuel : number = 0;
  public totalConsulAncien : number = 0;

  public date1: any;
  public date2: any;
  public totalEntretienParDate : any[] = [];
  public totalTodate: number = 0;
  dateForm: FormGroup;



  //formulaire permettant d'afficher les prénoms des consultants en fonction du manager
  managerForm: FormGroup;
  public manager: string;
  public consultantList: any[] = [];
  public AllConsultant: any[] = [];

//Informations personnelles des consultants
//public infoConsultants: any;
public config: any;
public order: string = "prenom";
public reverse: boolean = false;
public sortedCollection: any[];
searchText: string;
public listDetailconsultants = [];
public countDoublon : number = 0;



//variables permettant la suppression des favoris d'un manager par l'ADMIN
public AllFavorite: any[] = [];
public managerInFavoris: any[] = [];
favorisForm: FormGroup;
public dataFavorite = {
  idManager: "",
  manager: "",
}


//Variable permettant de stocker le profil des utilisateurs ayant le rôle ADMIN ou MANAGER
public firtNameManager: any;
public managers = [];
public newArray: any;

//Variable pour les statistiques sur la répartition des provenances des recrutements
public totalMonster : number = 0;
public totalApec : number = 0;
public totalAutres : number = 0;
public totalSpontane : number = 0;
public totalCooptInterne : number = 0;
public totalCoopteExterne : number = 0;
public totalLinkedIn : number = 0;
public totalNomDefini : number = 0;
public tableauStatProvenance: any[] = [];

//Variable pour les statistiques sur la répartition des provenances des recrutements (Année en cours)
public totalMonsterEncours : number = 0;
public totalApecEncours : number = 0;
public totalAutresEncours : number = 0;
public totalSpontaneEncours : number = 0;
public totalCooptInterneEncours : number = 0;
public totalCoopteExterneEncours : number = 0;
public totalLinkedInEncours : number = 0;
public totalNomDefiniEncours : number = 0;

//Variable pour les statistiques sur la répartition des provenances des recrutements (Année N-1)
public totalMonsterMoinUn : number = 0;
public totalApecMoinUn : number = 0;
public totalAutresMoinUn : number = 0;
public totalSpontaneMoinUn : number = 0;
public totalCooptInterneMoinUn : number = 0;
public totalCoopteExterneMoinUn : number = 0;
public totalLinkedInMoinUn : number = 0;
public totalNomDefiniMoinUn : number = 0;

//Variable pour les statistiques sur la répartition des provenances des recrutements (Année N-2)
public totalMonsterMoinDeux : number = 0;
public totalApecMoinDeux : number = 0;
public totalAutresMoinDeux : number = 0;
public totalSpontaneMoinDeux : number = 0;
public totalCooptInterneMoinDeux : number = 0;
public totalCoopteExterneMoinDeux : number = 0;
public totalLinkedInMoinDeux : number = 0;
public totalNomDefiniMoinDeux : number = 0;

//Variable pour les statistiques sur la répartition des provenances des recrutements (Année N-3)
public totalMonsterMoinTrois : number = 0;
public totalApecMoinTrois : number = 0;
public totalAutresMoinTrois : number = 0;
public totalSpontaneMoinTrois : number = 0;
public totalCooptInterneMoinTrois : number = 0;
public totalCoopteExterneMoinTrois : number = 0;
public totalLinkedInMoinTrois : number = 0;
public totalNomDefiniMoinTrois : number = 0;

//Variable pour les statistiques sur la répartition des provenances des recrutements (Année N-4)
public totalMonsterMoinQuatre : number = 0;
public totalApecMoinQuatre : number = 0;
public totalAutresMoinQuatre : number = 0;
public totalSpontaneMoinQuatre : number = 0;
public totalCooptInterneMoinQuatre : number = 0;
public totalCoopteExterneMoinQuatre : number = 0;
public totalLinkedInMoinQuatre : number = 0;
public totalNomDefiniMoinQuatre : number = 0;

//Regrouper les statistiques des répartitions des provenances en fonction des années
public currentYear: number;
public anneeMoinUn: number;
public anneeMoinDeux: number;
public anneeMoinTrois: number;
public anneeMoinQuatre: number;

//faire une recherche sur les stat des provenances des cooptations en fonction de la date
//choisie dans liste déroulante
statRecrutForm: FormGroup;
public newDate : any;
public anneeEncours : number;
public totalMonsterNewDate : number = 0;
public totalApecNewDate : number = 0;
public totalAutresNewDate : number = 0;
public totalSpontaneNewDate : number = 0;
public totalCooptInterneNewDate : number = 0;
public totalCoopteExterneNewDate : number = 0;
public totalLinkedInNewDate : number = 0;
public totalNomDefiniNewDate : number = 0;
public tableauDesDates  = [];
public tableauStatProvenanceNewDate: any[] = [];


  constructor(public _authService: AuthService,private dossierService: DossierService,  private _genericService: GenericService,
     private formBuilder: FormBuilder, private _router: Router, private orderPipe: OrderPipe, private _notifyService: NotificationService) {
 
   }

  ngOnInit() {
    this._authService.checkCredentials();
    this.getAlltotalEntretien();
    this.getAlltotalEntretienByManager();
    this.getConsultantByManager();
    this.getTotalConsultants();
    this.initFormManager();
    this.getAllCandiNonValid();
    this.getTotalDossiers();
    this.getAllCandiValid();
    this.getAllManagers();
    this.getInfoConsultants();
    this.getTotalStatDossier();
    this.getStatOriginRecuitment();
    this.getStatRecuitmentcurrentYear();
    this.getStatRecuitmentanneeMoinUn();
    this.getStatRecuitmentanneeMoinDeux();
    this.getStatRecuitmentanneeMoinTrois();
    this.getStatRecuitmentanneeMoinQuatre();
    this.user = new User();
    this.users.push(this.user);
    this.initFormdate(); 
    this.getAllFolderFavorite();
    this.initRemovFavoris();
    this.initstatRecrutForm();
    this.attestion = new Attestation();

  }



  // récupérer le prénom des utilisateurs ayant le role AMIN ou MANAGER
  getAllManagers(){
    this._genericService.getResource(environment.statsTotalManagers, true, 0)
    .subscribe(
      result =>{
        this.firtNameManager = result;
        for (let i = 0; i < this.firtNameManager.length; i++) {
          this.managers.push({
            prenom: this.firtNameManager[i].prenom, 
            nom: this.firtNameManager[i].nom, 
            telephone: this.firtNameManager[i].telephone, 
            email: this.firtNameManager[i].email, 
            profil: this.firtNameManager[i].roles[0].role, 
          });
        }
      },
      error =>{
      }
    );
  }



  //Récupérer les dossiers des anciens et collaborateurs actuels pour les stats sur la provenance de recrutement (année en cours)
 getStatOriginRecuitment(){
    this._genericService.getResource(environment.statsgetStatOriginRecuitment, true ,0)
    .subscribe(
      data => {
        for (let i = 0; i < data.length; i++) {
          if(data[i].fe.provenance == 'Monster') this.totalMonster += 1;
          else if(data[i].fe.provenance == 'Apec') this.totalApec += 1;
          else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedIn += 1;
          else if(data[i].fe.provenance == 'autres') this.totalAutres += 1;
          else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterne += 1;
          else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterne += 1;
          else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontane += 1;
          else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefini += 1;
          
        }

        //Calculer en pourcentage les provenances
        this.totalMonster = Math.round((this.totalMonster / data.length) * 100);
        this.totalApec = Math.round((this.totalApec / data.length) * 100);
        this.totalLinkedIn = Math.round((this.totalLinkedIn / data.length) * 100);
        this.totalAutres = Math.round((this.totalAutres / data.length) * 100);
        this.totalCoopteExterne = Math.round((this.totalCoopteExterne / data.length)  * 100);
        this.totalCooptInterne = Math.round((this.totalCooptInterne / data.length) * 100);
        this.totalSpontane = Math.round((this.totalSpontane / data.length) * 100);
        this.totalNomDefini = Math.round((this.totalNomDefini / data.length) * 100);

        /*this.tableauStatProvenance.push(
          {provenance: "Monster", pourcentage: this.totalMonster},
          {provenance: "Apec", pourcentage: this.totalApec},
          {provenance: "LinkedIn", pourcentage: this.totalLinkedIn},
          {provenance: "Autres", pourcentage: this.totalAutres},
          {provenance: "Cooptation externe", pourcentage: this.totalCoopteExterne},
          {provenance: "Cooptation interne", pourcentage: this.totalCooptInterne},
          {provenance: "Candidature spontanée", pourcentage: this.totalSpontane}
          );
          
          //Vérifier si l'on n'a pas de provenances non définies pour un collaborateur
          if(this.totalNomDefini > 0){
            this.tableauStatProvenance.push(
              {provenance: "Non défini", pourcentage: this.totalNomDefini}
              );
          }

        //Trier le tableau dans l'ordre décroissant de pourcentage
        this.tableauStatProvenance.sort((a, b) => {
          return b.pourcentage - a.pourcentage;
      });*/
      },
      error => {
      }
    );
  }

  //les stats sur la provenance de recrutement (année en cours)
  async getStatRecuitmentcurrentYear(){
    this._genericService.getResource(environment.statsgetStatRecuitmentcurrentYear, true ,0).subscribe(
      data =>{

        for (let i = 0; i < data.length; i++) {
          if(data[i].fe.provenance == 'Monster') this.totalMonsterEncours += 1;
          else if(data[i].fe.provenance == 'Apec') this.totalApecEncours += 1;
          else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedInEncours += 1;
          else if(data[i].fe.provenance == 'autres') this.totalAutresEncours += 1;
          else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterneEncours += 1;
          else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterneEncours += 1;
          else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontaneEncours += 1;
          else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefiniEncours += 1;
          
        }

        this.totalMonsterEncours = Math.round((this.totalMonsterEncours / data.length) * 100);
        this.totalApecEncours = Math.round((this.totalApecEncours / data.length) * 100);
        this.totalLinkedInEncours = Math.round((this.totalLinkedInEncours / data.length) * 100);
        this.totalAutresEncours = Math.round((this.totalAutresEncours / data.length) * 100);
        this.totalCoopteExterneEncours = Math.round((this.totalCoopteExterneEncours / data.length)  * 100);
        this.totalCooptInterneEncours = Math.round((this.totalCooptInterneEncours / data.length) * 100);
        this.totalSpontaneEncours = Math.round((this.totalSpontaneEncours / data.length) * 100);
        this.totalNomDefiniEncours = Math.round((this.totalNomDefiniEncours / data.length) * 100);


      },
      error =>{

      }
    )
  }

  //les stats sur la provenance de recrutement (année N-1)
  async getStatRecuitmentanneeMoinUn(){
    this._genericService.getResource(environment.statsgetStatRecuitmentanneeMoinUn, true ,0).subscribe(
      data =>{
        for (let i = 0; i < data.length; i++) {
          if(data[i].fe.provenance == 'Monster') this.totalMonsterMoinUn += 1;
          else if(data[i].fe.provenance == 'Apec') this.totalApecMoinUn += 1;
          else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedInMoinUn += 1;
          else if(data[i].fe.provenance == 'autres') this.totalAutresMoinUn += 1;
          else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterneMoinUn += 1;
          else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterneMoinUn += 1;
          else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontaneMoinUn += 1;
          else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefiniMoinUn += 1;
          
        }
        this.totalMonsterMoinUn = Math.round((this.totalMonsterMoinUn / data.length) * 100);
        this.totalApecMoinUn = Math.round((this.totalApecMoinUn / data.length) * 100);
        this.totalLinkedInMoinUn = Math.round((this.totalLinkedInMoinUn / data.length) * 100);
        this.totalAutresMoinUn = Math.round((this.totalAutresMoinUn / data.length) * 100);
        this.totalCoopteExterneMoinUn = Math.round((this.totalCoopteExterneMoinUn / data.length)  * 100);
        this.totalCooptInterneMoinUn = Math.round((this.totalCooptInterneMoinUn / data.length) * 100);
        this.totalSpontaneMoinUn = Math.round((this.totalSpontaneMoinUn / data.length) * 100);
        this.totalNomDefiniMoinUn = Math.round((this.totalNomDefiniMoinUn / data.length) * 100);

      },
      error =>{

      }
    )
  }

  //les stats sur la provenance de recrutement (année N-2)
getStatRecuitmentanneeMoinDeux(){
    this._genericService.getResource(environment.statsgetStatRecuitmentanneeMoinDeux, true ,0).subscribe(
      data =>{
        for (let i = 0; i < data.length; i++) {
          if(data[i].fe.provenance == 'Monster') this.totalMonsterMoinDeux += 1;
          else if(data[i].fe.provenance == 'Apec') this.totalApecMoinDeux += 1;
          else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedInMoinDeux += 1;
          else if(data[i].fe.provenance == 'autres') this.totalAutresMoinDeux += 1;
          else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterneMoinDeux += 1;
          else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterneMoinDeux += 1;
          else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontaneMoinDeux += 1;
          else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefiniMoinDeux += 1;
          
        }

        //Calculer en pourcentage les provenances
        this.totalMonsterMoinDeux = Math.round((this.totalMonsterMoinDeux / data.length) * 100);
        this.totalApecMoinDeux = Math.round((this.totalApecMoinDeux / data.length) * 100);
        this.totalLinkedInMoinDeux = Math.round((this.totalLinkedInMoinDeux / data.length) * 100);
        this.totalAutresMoinDeux = Math.round((this.totalAutresMoinDeux / data.length) * 100);
        this.totalCoopteExterneMoinDeux = Math.round((this.totalCoopteExterneMoinDeux / data.length)  * 100);
        this.totalCooptInterneMoinDeux = Math.round((this.totalCooptInterneMoinDeux / data.length) * 100);
        this.totalSpontaneMoinDeux = Math.round((this.totalSpontaneMoinDeux / data.length) * 100);
        this.totalNomDefiniMoinDeux = Math.round((this.totalNomDefiniMoinDeux / data.length) * 100);

      },
      error =>{

      }
    )
  }

  //les stats sur la provenance de recrutement (année N-3)
getStatRecuitmentanneeMoinTrois(){
    this._genericService.getResource(environment.statsgetStatRecuitmentanneeMoinTrois, true ,0).subscribe(
      data =>{
        for (let i = 0; i < data.length; i++) {
          if(data[i].fe.provenance == 'Monster') this.totalMonsterMoinTrois += 1;
          else if(data[i].fe.provenance == 'Apec') this.totalApecMoinTrois += 1;
          else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedInMoinTrois += 1;
          else if(data[i].fe.provenance == 'autres') this.totalAutresMoinTrois += 1;
          else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterneMoinTrois += 1;
          else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterneMoinTrois += 1;
          else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontaneMoinTrois += 1;
          else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefiniMoinTrois += 1;
          
        }

        //Calculer en pourcentage les provenances
        this.totalMonsterMoinTrois = Math.round((this.totalMonsterMoinTrois / data.length) * 100);
        this.totalApecMoinTrois = Math.round((this.totalApecMoinTrois / data.length) * 100);
        this.totalLinkedInMoinTrois = Math.round((this.totalLinkedInMoinTrois / data.length) * 100);
        this.totalAutresMoinTrois = Math.round((this.totalAutresMoinTrois / data.length) * 100);
        this.totalCoopteExterneMoinTrois = Math.round((this.totalCoopteExterneMoinTrois / data.length)  * 100);
        this.totalCooptInterneMoinTrois = Math.round((this.totalCooptInterneMoinTrois / data.length) * 100);
        this.totalSpontaneMoinTrois = Math.round((this.totalSpontaneMoinTrois / data.length) * 100);
        this.totalNomDefiniMoinTrois = Math.round((this.totalNomDefiniMoinTrois / data.length) * 100);
      },
      error =>{

      }
    )
  }

  // les stats sur la provenance de recrutement (année N-4)
getStatRecuitmentanneeMoinQuatre(){
    this._genericService.getResource(environment.statsgetStatRecuitmentanneeMoinQuatre, true ,0).subscribe(
      data =>{
        for (let i = 0; i < data.length; i++) {
          if(data[i].fe.provenance == 'Monster') this.totalMonsterMoinQuatre += 1;
          else if(data[i].fe.provenance == 'Apec') this.totalApecMoinQuatre += 1;
          else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedInMoinQuatre += 1;
          else if(data[i].fe.provenance == 'autres') this.totalAutresMoinQuatre += 1;
          else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterneMoinQuatre += 1;
          else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterneMoinQuatre += 1;
          else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontaneMoinQuatre += 1;
          else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefiniMoinQuatre += 1;
          
        }

        //Calculer en pourcentage les provenances
        this.totalMonsterMoinQuatre = Math.round((this.totalMonsterMoinQuatre / data.length) * 100);
        this.totalApecMoinQuatre = Math.round((this.totalApecMoinQuatre / data.length) * 100);
        this.totalLinkedInMoinQuatre = Math.round((this.totalLinkedInMoinQuatre / data.length) * 100);
        this.totalAutresMoinQuatre = Math.round((this.totalAutresMoinQuatre / data.length) * 100);
        this.totalCoopteExterneMoinQuatre = Math.round((this.totalCoopteExterneMoinQuatre / data.length)  * 100);
        this.totalCooptInterneMoinQuatre = Math.round((this.totalCooptInterneMoinQuatre / data.length) * 100);
        this.totalSpontaneMoinQuatre = Math.round((this.totalSpontaneMoinQuatre / data.length) * 100);
        this.totalNomDefiniMoinQuatre = Math.round((this.totalNomDefiniMoinQuatre / data.length) * 100);


        //Regrouper toutes les statistiques sur les provenances de cooptation.
        var year = new Date(); 
        this.currentYear = year.getFullYear();
        this.anneeMoinUn = this.currentYear - 1;
        this.anneeMoinDeux = this.anneeMoinUn - 1;
        this.anneeMoinTrois = this.anneeMoinDeux - 1;
        this.anneeMoinQuatre = this.anneeMoinTrois - 1;

        //Vérifier si nous avons des dossiers dont la provenance n'a pas été définie
        
        this.tableauStatProvenance.push(
          {provenance: "Monster", pourcentage: this.totalMonster, encours: this.totalMonsterEncours  + ' %', moinUn: this.totalMonsterMoinUn  + ' %',
          moinDeux: this.totalMonsterMoinDeux  + ' %', moinTrois:this.totalMonsterMoinTrois  + ' %', moinQuatre: this.totalMonsterMoinQuatre  + ' %'},

          {provenance: "Apec", pourcentage: this.totalApec, encours: this.totalApecEncours  + ' %', moinUn: this.totalApecMoinUn  + ' %',
          moinDeux: this.totalApecMoinDeux  + ' %', moinTrois:this.totalApecMoinTrois  + ' %', moinQuatre: this.totalApecMoinQuatre  + ' %'},

          {provenance: "LinkedIn", pourcentage: this.totalLinkedIn, encours: this.totalLinkedInEncours  + ' %', moinUn: this.totalLinkedInMoinUn  + ' %',
          moinDeux: this.totalLinkedInMoinDeux  + ' %', moinTrois:this.totalLinkedInMoinTrois  + ' %', moinQuatre: this.totalLinkedInMoinQuatre  + ' %'},
          
          {provenance: "Autres", pourcentage: this.totalAutres, encours: this.totalAutresEncours  + ' %', moinUn: this.totalAutresMoinUn  + ' %',
          moinDeux: this.totalAutresMoinDeux  + ' %', moinTrois:this.totalAutresMoinTrois  + ' %', moinQuatre: this.totalAutresMoinQuatre  + ' %'},

          {provenance: "Cooptation externe", pourcentage: this.totalCoopteExterne, encours: this.totalCoopteExterneEncours  + ' %', moinUn: this.totalCoopteExterneMoinUn  + ' %',
          moinDeux: this.totalCoopteExterneMoinDeux  + ' %', moinTrois:this.totalCoopteExterneMoinTrois  + ' %', moinQuatre: this.totalCoopteExterneMoinQuatre  + ' %'},

          {provenance: "Cooptation interne", pourcentage: this.totalCooptInterne, encours: this.totalCooptInterneEncours  + ' %', moinUn: this.totalCooptInterneMoinUn  + ' %',
          moinDeux: this.totalCooptInterneMoinDeux  + ' %', moinTrois:this.totalCooptInterneMoinTrois  + ' %', moinQuatre: this.totalCooptInterneMoinQuatre  + ' %'},

          {provenance: "Candidature spontanée", pourcentage: this.totalSpontane, encours: this.totalSpontaneEncours  + ' %', moinUn: this.totalSpontaneMoinUn  + ' %',
          moinDeux: this.totalSpontaneMoinDeux  + ' %', moinTrois:this.totalSpontaneMoinTrois  + ' %', moinQuatre: this.totalSpontaneMoinQuatre  + ' %' }

          );

        if(this.totalNomDefini > 0 || this.totalNomDefiniEncours > 0  || this.totalNomDefiniMoinUn > 0 ||
          this.totalNomDefiniMoinDeux > 0 ||  this.totalNomDefiniMoinTrois > 0 || this.totalNomDefiniMoinQuatre > 0 ){
            this.tableauStatProvenance.push(
              {provenance: "Non défini" , 
              pourcentage: this.totalNomDefini > 0 ? this.totalNomDefini : ' ', 
              encours: this.totalNomDefiniEncours > 0 ? this.totalNomDefiniEncours  + ' %' : ' ',
              moinUn: this.totalNomDefiniMoinUn > 0 ? this.totalNomDefiniMoinUn  + ' %' : ' ',
              moinDeux: this.totalNomDefiniMoinDeux > 0 ? this.totalNomDefiniMoinDeux  + ' %' : ' ', 
              moinTrois:this.totalNomDefiniMoinTrois > 0 ? this.totalNomDefiniMoinTrois  + ' %' : ' ', 
              moinQuatre: this.totalNomDefiniMoinQuatre > 0 ? this.totalNomDefiniMoinQuatre  + ' %' : ' '}
            );
        }

        //Trier le tableau dans l'ordre décroissant de pourcentage
        this.tableauStatProvenance.sort((a, b) => {
          return b.pourcentage - a.pourcentage;
      });
      
      this.anneeEncours = this.currentYear
      //Ajouter les années dans un tableau afin de les passer dynamiquement dans le champs select de la recherche
      this.anneeEncours = this.anneeEncours + 1;
      while(this.anneeEncours >= 2017){
        this.tableauDesDates.push(this.anneeEncours - 1)
        this.anneeEncours --
      }
      },
      error =>{
        
      }
    )
  }

   //Récupérer les statitiques de récrutement en fonction de l'année choisie
   initstatRecrutForm(){
    this.statRecrutForm  = this.formBuilder.group({
      newDate: ['', Validators.required],
  
    });
  }
  getStatRecuitmentParDate(){
    let formValue = this.statRecrutForm.value;
   console.log(formValue.newDate)
   this._genericService.searchConsultantWithBody(environment.statsgetStatRecuitmentParDate,  formValue, true, -1, this.sortKey)
    .subscribe(
      data => {
        console.log(data)
        if (data.length == 0) {
          this._notifyService.showWarning("Aucun résultat trouvé pour cette date", "Notification", 3000)

        }else{
          for (let i = 0; i < data.length; i++) {
            if(data[i].fe.provenance == 'Monster') this.totalMonsterNewDate += 1;
            else if(data[i].fe.provenance == 'Apec') this.totalApecNewDate += 1;
            else if(data[i].fe.provenance == 'LinkedIn') this.totalLinkedInNewDate += 1;
            else if(data[i].fe.provenance == 'autres') this.totalAutresNewDate += 1;
            else if(data[i].fe.provenance == 'Cooptation externe') this.totalCoopteExterneNewDate += 1;
            else if(data[i].fe.provenance == 'Cooptation interne') this.totalCooptInterneNewDate += 1;
            else if(data[i].fe.provenance == 'Candidature spontannée') this.totalSpontaneNewDate += 1;
            else if(data[i].fe.provenance == '' || data[i].fe.provenance == undefined || data[i].fe.provenance == null) this.totalNomDefiniNewDate += 1;
            
          }
  
          //Calculer en pourcentage les provenances
          this.totalMonsterNewDate = Math.round((this.totalMonsterNewDate / data.length) * 100);
          this.totalApecNewDate = Math.round((this.totalApecNewDate / data.length) * 100);
          this.totalLinkedInNewDate= Math.round((this.totalLinkedInNewDate / data.length) * 100);
          this.totalAutresNewDate = Math.round((this.totalAutresNewDate / data.length) * 100);
          this.totalCoopteExterneNewDate = Math.round((this.totalCoopteExterneNewDate / data.length)  * 100);
          this.totalCooptInterneNewDate = Math.round((this.totalCooptInterneNewDate / data.length) * 100);
          this.totalSpontaneNewDate = Math.round((this.totalSpontaneNewDate / data.length) * 100);
          this.totalNomDefiniNewDate = Math.round((this.totalNomDefiniNewDate / data.length) * 100);
  
          this.tableauStatProvenanceNewDate.push(
            {provenance: "Monster", pourcentage: this.totalMonsterNewDate},
            {provenance: "Apec", pourcentage: this.totalApecNewDate},
            {provenance: "LinkedIn", pourcentage: this.totalLinkedInNewDate},
            {provenance: "Autres", pourcentage: this.totalAutresNewDate},
            {provenance: "Cooptation externe", pourcentage: this.totalCoopteExterneNewDate},
            {provenance: "Cooptation interne", pourcentage: this.totalCooptInterneNewDate},
            {provenance: "Candidature spontanée", pourcentage: this.totalSpontaneNewDate}
            );
            
            //Vérifier si l'on n'a pas de provenances non définies pour un collaborateur
            if(this.totalNomDefiniNewDate > 0){
              this.tableauStatProvenanceNewDate.push(
                {provenance: "Non défini", pourcentage: this.totalNomDefiniNewDate}
                );
            }
  
          //Trier le tableau dans l'ordre décroissant de pourcentage
          this.tableauStatProvenanceNewDate.sort((a, b) => {
            return b.pourcentage - a.pourcentage;
        });
        }
        
      },
      error => {
      }
    )
  }


  // Permet d'arrondir à N chiffre après la virgule (2 décimales par défaut)
  roundDecimal(nombre: number, precision: number){
    var precision = precision || 2;
    var tmp = Math.pow(10, precision);
    return Math.round( nombre*tmp ) / tmp;
}


  //Récupérer tous les dossiers mis en favorite
  getAllFolderFavorite(){
    this._genericService.getResource(environment.statsgetAllFolderFavorite, true, 0)
    .subscribe(
      result => { 
        for (let i = 0; i < result.length; i++) {
          for (let j = 0; j < result[i].favorites.length; j++) {
            this.AllFavorite.push({
              manager: result[i].favorites[j].manager,
              idManager: result[i].favorites[j].idManager,
            });
          }
        }
        // Supprimer les doublons dans la liste dans le tableau
        this.managerInFavoris = this.AllFavorite.filter((thing, index) => {
          const _double = JSON.stringify(thing);
          return index === this.AllFavorite.findIndex(obj => {
            return JSON.stringify(obj) === _double;
          });
        });
      },
      error => {
      }
    );

  }

//Supprimer tous les  favoris d'un manager parti par l'ADMIN
initRemovFavoris(){
  this.favorisForm  = this.formBuilder.group({
    dataFavorite: ['', Validators.required],

  });
}
removeAllFavorisManager(){
  const formValue = this.favorisForm.value;
  if(formValue.dataFavorite == ""){
    this._notifyService.showWarning("Veuillez choisir un manager", "Oups", 3000)
  }else{
    if(confirm("Voulez vous Vraiment supprimer tous ses dossiers en favoris ?")){
      this._genericService.saveResource(environment.removeAllFavorisManager, formValue.dataFavorite, true, environment.contentTypes.json)
      .subscribe(
        ()=>{
          this._notifyService.showSuccess("Tous les dossiers ont été retirés des favoris", "Remove favorite", 2000)
          this.reloadPage();
        },
        ()=>{
          this._notifyService.showError("Erreur lors de la suppression des favoris de ce manager", "Remove favorite", 3000)
        }
      )
    }else{
      this.dataFavorite.idManager = "";
      this.dataFavorite.manager = "";
    }
  }
}


  //Récupérer les informations personnelles des consultants ainsi que les détails du contrat
  getInfoConsultants(){
    this._genericService.getResource(environment.statsgetInfoConsultants, true, 0)
    .subscribe(
      data =>{
        //configuration pour la pagination
        this.config = {
          itemsPerPage: 10,
          currentPage: 1,
          //totalItems: this.listDetailconsultants.length
        };
        //let contrat
        for (let i = 0; i < data.length; i++) {
          this.listDetailconsultants.push({ prenom: data[i].general.prenom, 
            nom: data[i].general.nom, 
            telephone: data[i].general.telephone, 
            email: data[i].general.email,
            profil: data[i].general.profil, 
            dateDemarrage: data[i].dernierContrat.dd, 
            typeContrat: data[i].dernierContrat.natureContrat, 
            responsable: data[i].dernierContrat.responsable,
            adresse: data[i].adresse,
            dateNaissance: data[i].general.dateNaissance,
            lieuNaissance: data[i].general.lieuNaissance
          });
        }
        // Transformer les champs pour les natures de contrat
        for (let j = 0; j < this.listDetailconsultants.length; j++) {
          if (this.listDetailconsultants[j].typeContrat === "cdi") {
            this.listDetailconsultants[j].typeContrat = "CDI"
          }
          else if(this.listDetailconsultants[j].typeContrat === "freelance"){
            this.listDetailconsultants[j].typeContrat = "Sous-traitant"
          }else{
            this.listDetailconsultants[j].typeContrat = "Stagiaire / Alternant"
          }       
        }
        //Filter les données en supprimant les doublons
        for (let j = 0; j < this.listDetailconsultants.length; j++){
          for(let k = 0; k < this.managers.length; k++){
            if(this.listDetailconsultants[j].prenom == this.managers[k].prenom  && this.listDetailconsultants[j].nom == this.managers[k].nom){
              delete this.listDetailconsultants[j];                                                                                 
              this.countDoublon  = this.countDoublon + 1;
            }
            
        }
      }
        // Rajouter le profil des ADMIN ou MANAGER dans la liste des collaborateurs
        this.newArray = [...this.listDetailconsultants, ...this.managers];
      },
      error =>{
        console.log(error)
      }
    )
  }
  //pagination du tableau des consultants
  pageChanged(event: any){
    this.config.currentPage = event;
  }

  //Ranger les élements du tableau
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }


  //Récupérer le nombre total de dossiers
  getTotalDossiers(){
    this._genericService.getResource(environment.statsTotalDossier, true ,0)
    .subscribe(
      result => { 
        this.totalDossiers = result.data;
      },
      error => {
      }
    );
  }

  //Total statistique dossier
  getTotalStatDossier(){
    return this.getAllCandiValid() + this.totalCandiNonValid + this.totalConsulActuel + this.totalConsulAncien;
  }


  //consulter le nombre d'entretien entre deux dates
  initFormdate(){
    this.dateForm  = this.formBuilder.group({
      date1: ['', Validators.required],
      date2: ['', Validators.required],

    });
  }
  getInterviewsBetweenTwodates(){
    this.totalTodate = 0;
    let formValue = this.dateForm.value;
    if (formValue['date1'] > formValue['date2'] ) {
      this._notifyService.showError("La date de fin doit être supérieure à la date de début", "Attention", 3000)
      /*this.errorMessage = "La date de fin doit être supérieure à la date de début";
      this.MsgError = this.errorMessage;
      this.resetErrorMessage();*/
    }
    this._genericService.searchConsultantWithBody(environment.statsgetInterviewsBetweenTwodates,  formValue, true, -1, this.sortKey)
    .subscribe(
      result => {
        this.totalEntretienParDate = result.data;
        if (this.totalEntretienParDate.length == 0) {
          this._notifyService.showWarning("Aucun résultat trouvé entre ces dates", "Notification", 3000)
          /*this.errorMessage = "Aucun résultat trouvé entre ces dates";
          this.MsgError = this.errorMessage;
          this.resetErrorMessage(); */
        }else{
          for (let i = 0; i < this.totalEntretienParDate.length; i++) {
            this.totalTodate += this.totalEntretienParDate[i].total;
          }
        }
        
      },
      error => {
      }
    );
  }
  
  
  // Récupérer le nombre total de candidatures non validées
  getAllCandiNonValid(){
    this._genericService.getResource(environment.statsTotalCandiNonValid, true ,0)
    .subscribe(
      result => { 
        this.totalCandiNonValid = result.data;
      },
      error => {
      }
    );
  }


  // Récupérer le nombre total de candidatures validées
  getAllCandiValid(){
      return (this.totalDossiers - (this.totalCandiNonValid + this.totalConsulActuel + this.totalConsulAncien ))
      }

  //Liste des Consultants (prénom) par Manager.
  initFormManager(){
    this.managerForm  = this.formBuilder.group({
      manager: ['', Validators.required]
    });
  }
  getNameConsultantByManager(){
    let formValue = this.managerForm.value;
    this._genericService.searchConsultantWithBody(environment.statsgetnameConsultantByManager, formValue, true, -1, this.sortKey)
        .subscribe(
          collaborateur =>
          {
            this.consultantList = collaborateur;
          },
          error => {
            this.showSpinner = false;
            //this.errorMessage = <any>error
          }
        );
  }



  // Récupérer le nombre total d'entretiens
  getAlltotalEntretien(){
    this._genericService.getResource(environment.statsTotalEntretien, true ,0)
    .subscribe(
      result => { 
        this.totalEntretien = result.data[0].total_entretien;
      },
      error => {
      }
    );
  }

  // Récupérer le nombre total d'entretiens par manager
  getAlltotalEntretienByManager(){
    this._genericService.getResource(environment.statsTotalEntretienParManager, true ,0)
    .subscribe(
      result => {
        this.totalEntretienParManager = result.data
      },
      error => {
      }
    );
  }

  //Nombre total de consultants (consultants actuels et anciens consultants) par manager
  getConsultantByManager(){
    this._genericService.getResource(environment.statsgetConsultantByManager, true ,0)
    .subscribe(
      data => {
        this.AllConsultant = data
        
        for (let i = 0; i < this.AllConsultant.length; i++) {
          this.newAndOldConsultant.push({ manager: this.AllConsultant[i]._id, 
          Consultants: (this.AllConsultant[i].Consultants.length - this.AllConsultant[i].AncienConsultants.length), 
          AnciensConsultants: this.AllConsultant[i].AncienConsultants.length})
        }

        //Calcul le nombre total d'anciens et nouveaux consultants pour les managers
        for (let j = 0; j < this.newAndOldConsultant.length; j++) {
          this.totalConsulActuel += this.newAndOldConsultant[j].Consultants;
          this.totalConsulAncien += this.newAndOldConsultant[j].AnciensConsultants;   
        }
        
      },
      error => {
      }
    );
  }


  // Nombre total 
  getTotalConsultants(){
    this._genericService.getResource(environment.statsTotalConsultants, true ,0)
    .subscribe(
      result => { 
        this.totalConsultants = result.data;
      },
      error => {
      }
    );
  }


  register(isValid: boolean): void {
    this.user.nom = this.user.nom.trim().replace(/-/g, " ")
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ')
      .toUpperCase();

      let prenom = this.user.prenom.trim().replace(/-/g, ' ')
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ').split(' ');

      let pp="";
      for(let i=0 ; i < prenom.length ; i++ ) {
        let lettreUn = prenom[i][0].toUpperCase();
        let resteMot = prenom[i].substring(1).toLowerCase();
        pp= pp + lettreUn + resteMot+' ';
      }
      this.user.prenom = pp.trim();

      this.user.email = this.user.email.trim().toLowerCase();

    if (isValid) {
      if (this.user.password !== this.pwd) {
        //this.errorMessage = ' Passwords don\'t match ';
        this._notifyService.showError("Passwords don\'t match ", "Attention", 3000)
   
      } else {
        //this.user.roles[0].role = this.user.role;

      this._genericService.saveResource(environment.addUser, this.user, true, environment.contentTypes.json)
      .subscribe(
        data => {
         /*window.scroll(0,0);
          this.successMessage = "Utilisateur créé avec succés";
          this.justSaved = this.successMessage;
          this.resetSuccesMessage();*/
          this._notifyService.showSuccess("Utilisateur créé avec succés", "Registration", 3000)

        },
        error => {
          //this.showSpinner = false;
          /*window.scroll(0,0);
          this.errorMessage = "Erreur d'ajout d'un nouveau utilisateur'";
          this.MsgError = error.message;
          this.resetErrorMessage();*/
          this._notifyService.showError("Erreur d'ajout d'un nouveau utilisateur", "Registration", 3000)
        }
       );
      }
    }
  }

  public search(isValid){
    this.reset = false;
    /*this.errorMessage = "";
    this.MsgError = this.errorMessage ;
    this.resetErrorMessage();*/
    if(isValid){
      this.loadPage(1, this.sortDir, 'nom');
    }
  }

  loadPage(index, sortDir, sortKey){
      this.page = index;
      this.showSpinner = true;

      let body = {
        critere : this.critere,
        page :  this.page
      };

      if(body.critere.nom != undefined) {
        body.critere.nom = String(body.critere.nom).trim()
        .replace(/-/g, " ")
        .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
        .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
        .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u");
      }
      if(body.critere.prenom != undefined) {
        body.critere.prenom = String(body.critere.prenom).trim()
        .replace(/-/g, " ")
        .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
        .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
        .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u");
      }


      this._genericService.searchWithBody(environment.searchUsersUrl , body, true, this.sortDir, this.sortKey)
      .subscribe(
        data => {
            this.success(data)
        },
        error => {
          /*this.showSpinner = false;
          this.errorMessage = error,
          this.MsgError = this.errorMessage;
          this.resetErrorMessage();*/
        }
      );
  }

  success(result){
    this.totalPages = new Array(result.pages);
    this.showSpinner = false;
    this.total = result.pages;

    let startPage: number, endPage: number;

    if (this.total <= 5) {
      startPage = 1;
      endPage = this.total;
      }
      else {
        if (this.page <= 3) {
            startPage = 1;
            endPage = 5;
        }
        else if (this.page + 1 >= this.total) {
                startPage = this.total - 4;
                endPage = this.total;
            } else {
                startPage = this.page - 2;
                endPage = this.page + 2;
            }
    }


    this.pages= _.range(startPage, endPage + 1);


    this.result = result.data;
    this.users = this.result;

    this.dataAvailable = true;
  }

  // Page suivante
  next(){
    if(this.page < this.total ){
      this.loadPage(this.page+1, this.sortDir, this.sortKey);
    }
  }

  //Page précédante
  previous(){
    if(this.page > 1){
      this.loadPage(this.page-1, this.sortDir, this.sortKey);
    }
  }

  clear(){
    this.critere.nom = undefined;
    this.critere.prenom = undefined,
    this.critere.role = undefined,
    this.reset = true
  }

//récupérer un utilisateur à partir de son identifiant
  getUser(user){

    this._genericService.getResourceWithPassingParameter(environment.userUrl , user._id, true, environment.contentTypes.json)
   .subscribe(
     data => {
       this.user = data;
      /*window.scroll(0,0);
      this.successMessage = "Utilisateur mis à jour avec succés";
      this.justSaved = this.successMessage;
      // this.loadPage(this.page, this.sortDir, this.sortKey);
      this.resetSuccesMessage();*/
      this._notifyService.showSuccess("Utilisateur mis à jour avec succés", "Update", 3000)

       
     },
     error => {
       this.showSpinner = false;
       /*window.scroll(0,0);
       this.errorMessage = "Erreur de mise à jour d'un utilisateur",
       this.MsgError = this.errorMessage;
       this.resetErrorMessage();*/
      this._notifyService.showError("Erreur de mise à jour d'un utilisateur", "Update", 3000)

     }
   );

  }


   //Supprimer un utilisateur à partir de son identifiant
  deleteUser(user){
    if ( confirm( "Voulez vous vraiment supprimer l'utilisateur " + user.nom + ' ' + user.prenom + ' ?') ) {
      // Code à éxécuter si le l'utilisateur clique sur "OK"
      this.getUser(user);
        //let users = this.users.splice(index,1);
      // this.users = users;

      this._genericService.deleteResource(environment.userUrl , user._id, true)
      .subscribe(
        data => {

          //window.scroll(0,0);
          this._notifyService.showSuccess("Utilisateur supprimé avec succés", "Delete", 3000)
          //this.successMessage = "Utilisateur supprimé avec succés";
          //this.justSaved = this.successMessage;
          this.loadPage(this.page, this.sortDir, this.sortKey);
          //this.resetSuccesMessage();
        },
        error => {
          this.showSpinner = false;
          /*window.scroll(0,0);
          this.errorMessage = "Erreur de suppression d'un utilisateur",
          this.MsgError = this.errorMessage;
          this.resetErrorMessage();*/
          this._notifyService.showError("Erreur de suppression d'un utilisateur", "Delete", 3000)

        }
      );
    }
  }


  // éditer un utilisateur à partir de son identifiant
  editUser(user){
    if ( confirm( "Voulez vous vraiment modifier l'utilisateur  ?") ) {

    this.user = user;
    this.user.nom = this.user.nom.trim().replace(/-/g, " ")
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ')
      .toUpperCase();

      let prenom = this.user.prenom.trim().replace(/-/g, ' ')
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ').split(' ');

      let pp="";
      for(let i=0 ; i < prenom.length ; i++ ) {
        let lettreUn = prenom[i][0].toUpperCase();
        let resteMot = prenom[i].substring(1).toLowerCase();
        pp= pp + lettreUn + resteMot+' ';
      }
      this.user.prenom = pp.trim();
      this.user.email = this.user.email.trim().toLowerCase();

    this._genericService.saveResource(environment.userUrl, user, true, environment.contentTypes.json)
    .subscribe(
      (data) => {
        /*window.scroll(0,0);
        this.successMessage = "Utilisateur modifié avec succés";
        this.justSaved = this.successMessage;
        this.resetSuccesMessage();*/
        this._notifyService.showSuccess("Utilisateur modifié avec succés", "Edit", 3000)

      },
      error => {
        //this.showSpinner = false;
        /*window.scroll(0,0);
        this.errorMessage = "Erreur de modification  de l'utilisateur";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
        this._notifyService.showError("Erreur de modification  de l'utilisateur", "Edit", 3000)
      }
     );
    }else{
      this.user = user;
    }
  }


  // Rendre le compte d'un utilisateur inactif (passer isActive === false)
  updateAndAricheUser(user){
    if ( confirm( "Voulez vous vraiment archiver le compte de" + ' ' + user.prenom + ' ?') ) {
    
      this.user = user;
      
    this._genericService.saveResource(environment.archiveAccountUser, user, true, environment.contentTypes.json)
    .subscribe(
      data => {
       /* window.scroll(0,0);
        this.successMessage = "Utilisateur archivé avec succès";
        this.justSaved = this.successMessage;
        this.resetSuccesMessage();*/
        this._notifyService.showSuccess("Utilisateur archivé avec succès", "Archive", 3000)
        this.reloadPage();
        //window.location.reload();
      },
      error => {
        //this.showSpinner = false;
        /*window.scroll(0,0);
        this.errorMessage = "Erreur d'archivage  de l'utilisateur";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
        this._notifyService.showError("Erreur d'archivage  de l'utilisateur", "Archive", 3000)
      }
     );
    }else{
      this.user = user;
    }
  }


    // réactiver le compte d'un utilisateur archivé (passer isActive === true)
    reactivateAccountUser(user){
      if ( confirm( "Voulez vous vraiment réactiver le compte de" + ' ' + user.prenom + ' ?') ) {
      
        this.user = user;
        
      this._genericService.saveResource(environment.reactivateAccountUser, user, true, environment.contentTypes.json)
      .subscribe(
        data => {
          /*window.scroll(0,0);
          this.successMessage = "Utilisateur réactivé avec succès";
          this.justSaved = this.successMessage;
          this.resetSuccesMessage();*/
          //window.location.reload();
          this._notifyService.showSuccess("Utilisateur réactivé avec succès", "Reactiver", 3000);
          this.reloadPage();         
        },
        error => {
          //this.showSpinner = false;
          /*window.scroll(0,0);
          this.errorMessage = "Erreur de réactivation pour l'utilisateur";
          this.MsgError = error.message;
          this.resetErrorMessage();*/
          this._notifyService.showError("Erreur de réactivation pour l'utilisateur", "Reactiver", 3000)
        }
       );
      }else{
        this.user = user;
      }
    }



    // tri en fonction du nom
    onSortNomClick(event) {
      let target = event.currentTarget,
        classList = target.classList;
      this.sortKey = 'nom';

      if (classList.contains('fa-chevron-up')) {
        classList.remove('fa-chevron-up');
        classList.add('fa-chevron-down');
        this.sortDir=-1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      } else {
        classList.add('fa-chevron-up');
        classList.remove('fa-chevron-down');
        this.sortDir=1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      }
    }

    // tri en fonction du prenom
    onSortPrenomClick(event) {
      let target = event.currentTarget,
        classList = target.classList;

      this.sortKey = 'prenom';

      if (classList.contains('fa-chevron-up')) {
        classList.remove('fa-chevron-up');
        classList.add('fa-chevron-down');
        this.sortDir=-1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      } else {
        classList.add('fa-chevron-up');
        classList.remove('fa-chevron-down');
        this.sortDir=1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      }
    }



  reloadPage(){
    setTimeout(()=>{
      window.location.reload();
    }, 3000);
  } 

  /*resetSuccesMessage(){
    setTimeout(()=>{
      this.justSaved = '';
    }, 6000);
  }*/

  /*reloadPage(){
    setTimeout(()=>{
      window.location.reload();
    }, 6000);
  }*/


// télécharger les tables en CSV
public downloadCSV(csv, filename) {
  var csvFile: any;
  var downloadLink: any;

  csvFile = new Blob([csv], {type: "text/csv"});
  downloadLink = document.createElement("a");
  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
}


// exporter en CSV Nombre d'entretiens par manager
exportTableToCSV(filename:any) {
var csv = [];
const dataTable = document.getElementById("dataTable");
var rows = dataTable.querySelectorAll("tr");
for (var i = 0; i < rows.length; i++) {
    var row = [], cols = rows[i].querySelectorAll("td, th");
    
    for (var j = 0; j < cols.length; j++) 
        row.push(cols[j].innerHTML);
    
    csv.push(row.join(";"));        
}

// Download CSV file
this.downloadCSV(csv.join("\n"), filename);
}

//exporter en CSV Nombre de consultants par manager
exportTableToCSV2(filename:any) {
var csv = [];
const dataTable = document.getElementById("dataTable2");
var rows = dataTable.querySelectorAll("tr");

for (var i = 0; i < rows.length; i++) {
    var row = [], cols = rows[i].querySelectorAll("td, th");
    
    for (var j = 0; j < cols.length; j++) 
        row.push(cols[j].innerHTML);
    
    csv.push(row.join(";"));        
}

// Download CSV file
this.downloadCSV(csv.join("\n"), filename);
}

//exporter en CSV Quelques statistiques sur les dossiers
exportTableToCSV3(filename:any) {
  var csv = [];
  const dataTable = document.getElementById("dataTable3");
  var rows = dataTable.querySelectorAll("tr");
  
  for (var i = 0; i < rows.length; i++) {
      var row = [], cols = rows[i].querySelectorAll("td, th");
      
      for (var j = 0; j < cols.length; j++) 
          row.push(cols[j].innerHTML);
      
      csv.push(row.join(";"));        
  }
  
  // Download CSV file
  this.downloadCSV(csv.join("\n"), filename);
  }

//exporter en CSV le nombre d'entretien entre deux dates
  exportTableToCSV4(filename:any) {
    let formValue = this.dateForm.value;
    filename = filename + formValue['date1'] + "_et"+"_"+ formValue['date2']+".csv"
    var csv = [];
    const dataTable = document.getElementById("dataTable4");
    var rows = dataTable.querySelectorAll("tr");
    
    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll("td, th");
        
        for (var j = 0; j < cols.length; j++) 
            row.push(cols[j].innerHTML);
        
        csv.push(row.join(";"));        
    }
    
    // Download CSV file
    this.downloadCSV(csv.join("\n"), filename);
    }

    //Exporter en CSV la répartition des provenances des recrutements
    exportTableToCSV5(filename:any) {
      var csv = [];
      const dataTable = document.getElementById("dataTable5");
      var rows = dataTable.querySelectorAll("tr");
      
      for (var i = 0; i < rows.length; i++) {
          var row = [], cols = rows[i].querySelectorAll("td, th");
          
          for (var j = 0; j < cols.length; j++) 
              row.push(cols[j].innerHTML);
          
          csv.push(row.join(";"));        
      }
      
      // Download CSV file
      this.downloadCSV(csv.join("\n"), filename);
      }
    
      //Exporter en CSV la répartition des provenances par date choisie
      exportTableToCSV6(filename:any) {
        let formValue = this.statRecrutForm.value;
        filename = filename + formValue['newDate'] + ".csv"
        var csv = [];
        const dataTable = document.getElementById("dataTable6");
        var rows = dataTable.querySelectorAll("tr");
        
        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll("td, th");
            
            for (var j = 0; j < cols.length; j++) 
                row.push(cols[j].innerHTML);
            
            csv.push(row.join(";"));        
        }
        
        // Download CSV file
        this.downloadCSV(csv.join("\n"), filename);
        }

//Génerer une attestation pour le collaborateur generateAttestation

getData(infoUser: any){
  this.attestion.civilite = this.attestion.civilite;
  this.attestion.prenom = infoUser.prenom.trim();
  this.attestion.nom = infoUser.nom.trim();
  this.attestion.email = infoUser.email.trim();
  this.attestion.dateNaissance = this.formatDateForDisplay(infoUser.dateNaissance);
  this.attestion.lieuNaissance = infoUser.lieuNaissance.trim();
  this.attestion.adresse = infoUser.adresse.rue + ' ' + infoUser.adresse.cp + ' ' + infoUser.adresse.ville;
  this.attestion.profil = infoUser.profil;
  this.attestion.dateDebutContrat = this.formatDateForDisplay(infoUser.dateDemarrage);
}
  async generateAttestationPDF(action = 'open') { 
        
    let civility1 = this.attestion.civilite === 'M.'? 'Il' : 'Elle';
    let civility2 = this.attestion.civilite === 'M.'? 'employé' : 'employée';
    let civility3 = this.attestion.civilite === 'M.'? 'il' : 'elle';
    let civility4 = this.attestion.civilite === 'M.'? 'né' : 'née';

    let docDefinition = {
      
      content: [
        {
          image: await this.getBase64ImageFromURL(
            "../../assets/images/logoAttestation.png"),
            alignment: 'right',
            width: 60,
            height: 60
        },
        {
          columns: [
            [
              {
                text: 'WELL’D',
                bold:true,
                fontSize: 10,
              },
              { 
                text: 'Complexe Nextdoor',
                bold:true,
                fontSize: 10,
              },
              { 
                text: '41, rue Camille Desmoulins',
                bold:true,
                fontSize: 10,
              },
              { 
                text: '92130 Issy-Les-Moulineaux',
                bold:true,
                fontSize: 10,
               },
               { 
                text: 'RCS Nanterre 821 716 511',
                bold:true,
                fontSize: 10,
               },
               { 
                text: 'SIRET : 821716511 00018 \n\n\n\n\n',
                bold:true,
                fontSize: 10,
               }
            ]
          ]
        },
        {
          text: 'Attestation de Travail \n\n\n',
          fontSize: 20,
          alignment: 'center',
          bold:true,
          color: '#0000'
        },
        { 
          text: 'Je, soussigné Nizar Ben Youssef, agissant en qualité de Directeur Général de WELL’D, certifie\n'
        },
        { 
          text: `que ${this.attestion.civilite} ${this.attestion.nom} ${this.attestion.prenom}, ${civility4} le ${this.reformatDate(this.attestion.dateNaissance)} à ${this.attestion.lieuNaissance}, et demeurant au ${this.attestion.adresse}, est ${civility2} dans notre société sous Contrat à Durée Indéterminée, en qualité de ${this.attestion.profil}, depuis le ${this.reformatDate(this.attestion.dateDebutContrat)} : sa période d’essai est validée, ${civility3} n’est ni en période de préavis ni en cours de licenciement.\n\n`
        },

        { 
          text: `${civility1} perçoit un salaire brut mensuel de ${this.attestion.salaireBrut} euros hors primes.\n\n\n\n`,
        },
        { 
          text: 'Fait à Issy-Les-Moulineaux,\n\n',
          alignment: 'right',
        },
        { 
          text: `Le ${new Date().toLocaleDateString('pt-PT')}\n\n\n`,
          alignment: 'right',
        },
        {
          image: await this.getBase64ImageFromURL(
            "../../assets/images/signature.png"),
            alignment: 'right',
            width: 220,
            height: 130
        },
        {
          margin: [10, 130],
          text:[
            { 
              text: 'WELL’D',
              style: 'small',
              color: '#0000CD'
            },
            { 
              text: ' – 41 rue Camille Desmoulins. 92130 Issy-Les-Moulineaux \n\n',
              style: 'small',
            },
            {
              text: 'www.welld.fr',
              style: 'small',
              color: '#0000CD'
            },
            {
              text: ' – SAS au capital de 10 000 € - RCS Nanterre 821 716 511',
              style: 'small',
            },
             
          ]
        }
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true
        },
        subheader: {
          fontSize: 15,
          bold: true
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8,
          alignment: 'center',
        },
      }
    };   
    
    if(action==='download'){    
      pdfMake.createPdf(docDefinition).download(`Attestation-Employeur-${this.attestion.prenom}.pdf`);
    }else if(action==='envoyer'){  
      this.infoData.prenom = this.attestion.prenom;
      this.infoData.email = this.attestion.email;
      this.infoData.pdf = docDefinition;
      this._genericService.saveResource(environment.sendWorkCertificate ,this.infoData, true, environment.contentTypes.json)
      .subscribe(
        success => {
         this._notifyService.showSuccess("L'attestation à été envoyé avec succès", "Attestation", 3000)
          
        },
        error => {
          this.showSpinner = false;
         this._notifyService.showError("Erreur lors de l'envoie du fichier", "Attestation", 3000)
   
        }
      );
    }else{
      pdfMake.createPdf(docDefinition).open();          
    }
    
  }    
      


    //Obtenez l'URL des données au format base64 à partir de l'URL de l'image externe
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = error => {
          reject(error);
        };
        img.src = url;
      });
    }



  // formatage des dates
   formatDateForDisplay(date: any){
    if(date != undefined)
      return date.substr(0,10);
  }

  //Afficher les dates au format JJ/MM/AAAA
  reformatDate(dateStr: any){
    return dateStr.toString().split("-").reverse().join("/");
  }


}



// WEBPACK FOOTER //
// ./src/app/administration/administration.component.ts